import React from 'react'
import { Link } from 'react-router-dom'
import { Battery } from '../../../shared/types/battery'
import { useCart } from '../../cart/contexts/CartContext'
import { useScrapPreferenceModal } from '../../../contexts/ScrapPreferenceContext'
import { useToast } from '../../../contexts/ToastContext'
import { formatPrice } from '../../../shared/utils/checkoutHelpers'
import { buildImageUrl } from '../../../config'

interface SimpleProductCardProps {
  product: Battery
  imageError: boolean
  onImageError: (productId: string) => void
}

const SimpleProductCard: React.FC<SimpleProductCardProps> = ({ product, imageError, onImageError }) => {
  const { addItem } = useCart()
  const scrapModal = useScrapPreferenceModal()
  const { addToast } = useToast()

  const handleAddToCart = () => {
    if (scrapModal?.addItemWithScrapModal) {
      scrapModal.addItemWithScrapModal(product, 1, true)
    } else {
      addItem(product)
      addToast({
        type: 'success',
        title: 'Produto adicionado',
        message: `${product.name} foi adicionado ao carrinho`
      })
    }
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 hover:border-blue-300 hover:shadow-md transition-all duration-200 overflow-hidden flex flex-col h-full">
      {/* Imagem */}
      <Link to={`/produto/${product.slug}`} className="block relative bg-gray-50 h-40 overflow-hidden">
        {!imageError && product.images && product.images.length > 0 ? (
          <img
            src={buildImageUrl(product.images[0]) as string}
            alt={product.name}
            onError={() => onImageError(product.id)}
            className="w-full h-full object-contain p-2"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
            <svg className="w-12 h-12 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
            </svg>
          </div>
        )}
        {product.discount && (
          <div className="absolute top-2 left-2">
            <span className="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded">
              -{product.discount}%
            </span>
          </div>
        )}
      </Link>

      {/* Conteúdo */}
      <div className="p-4 flex flex-col flex-1">
        {/* Nome */}
        <Link to={`/produto/${product.slug}`}>
          <h3 className="text-sm font-semibold text-gray-900 mb-2 line-clamp-2 hover:text-blue-600 transition-colors">
            {product.name}
          </h3>
        </Link>

        {/* Preço */}
        <div className="mt-auto">
          {product.originalPrice && product.originalPrice > product.price && (
            <div className="text-xs text-gray-500 line-through mb-1">
              {formatPrice(product.originalPrice)}
            </div>
          )}
          <div className="text-lg font-bold text-blue-600 mb-3">
            {formatPrice(product.price)}
          </div>

          {/* Botão */}
          <button
            onClick={handleAddToCart}
            disabled={product.stock === 0}
            className="w-full px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
          >
            {product.stock > 0 ? 'Adicionar' : 'Indisponível'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default SimpleProductCard

